import { INSTALLATION_PILE_CODES, type InstallationPileCode } from '../../types'
import { wonFormCheckInput, wonFormCheckLabel, wonFormCheckRow } from '../../formCheckClasses'

interface Props {
  isView: boolean
  selectedPileSize: InstallationPileCode | ''
  setSelectedPileSize: (code: InstallationPileCode | '') => void
}

const InstallationProductPileSection: React.FC<Props> = ({
  isView,
  selectedPileSize,
  setSelectedPileSize,
}) => {
  return (
    <div className='col-12'>
      <div className='card'>
        <div className='card-header'>
          <div className='card-title fw-bold'>งานด้านสินค้า</div>
        </div>
        <div className='card-body'>
          <div className='fw-bold mb-4'>เปิดงานใช้เสาเข็มขนาด</div>
          <div className='d-flex flex-wrap align-items-center gap-5'>
            {INSTALLATION_PILE_CODES.map(code => (
              <div key={code} className={wonFormCheckRow}>
                <input
                  className={wonFormCheckInput}
                  type='radio'
                  name='won-install-pile-size'
                  id={`won-install-pile-size-${code}`}
                  checked={selectedPileSize === code}
                  disabled={isView}
                  onChange={() => setSelectedPileSize(code)}
                />
                <label className={wonFormCheckLabel} htmlFor={`won-install-pile-size-${code}`}>
                  {code}
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default InstallationProductPileSection
